import { render } from "./Footer copy.vue?vue&type=template&id=2ca833b2"
const script = {}

import "./Footer copy.vue?vue&type=style&index=0&id=2ca833b2&lang=css"

import exportComponent from "/opt/build/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__